"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const types_1 = require("./types");
const uinode_1 = require("./uinode");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uinode_1.file_assignedRepaymentTape.isIntermediateRecord(tape), `intermediateToUINodes: tape is not an ${types_1.artifactType}`);
    const { id, loanProductSlug, artifactSlug, creditFacilitySlug } = tape;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            loanProductSlug,
            creditFacilitySlug,
        },
    };
    return { tapeNode, operationNode: null };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node } = params;
    (0, common_1.finleyAssert)(uinode_1.file_assignedRepaymentTape.isNode(node), `uiNodesToIntermediate: node is not a assignedRepaymentTape node: ${node.metadata.tapeBuilderNodeType}`);
    const { configuration, metadata } = node;
    const { tapeBuilderNodeId } = metadata;
    const { artifactSlug, loanProductSlug, creditFacilitySlug } = configuration;
    const record = {
        id: tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug,
        loanProductSlug,
        externalFilename: null,
        configuration: {},
    };
    return { record, operationNode: null };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map